<template>
    <!-- 状態遷移を表示 -->
    <div class="container header-margin mx-auto">
        <div class="row state">
            <div class="col-md-2">送付先入力　→</div>
            <div class="col-md-2">個数指定　→</div>
            <div class="col-md-2 active">確認画面　→</div>
            <div class="col-md-2">お支払い</div>
        </div>

        <div class="py-3">
            <h4 class="h4 font-weight-normal text-primary text-center">
                購入内容の確認
            </h4>
        </div>

        <div class="row">
            <div class="offset-col-md-2 col-md-6 text-md-right">
                <h4 class="py-3">購入数と必要HEC数</h4>
            </div>
            <div class="col-md-6">
                <p>購入数：{{ this.formData.amount }} 個</p>
                <p>必要HEC合計：{{ this.formData.total }} HEC</p>
            </div>
            <hr class="col-12">
        </div>
        <div class="row">
            <div class="offset-md-2 col-md-4 col-md-offset-3">
                <h4 class="py-3">注文者情報</h4>
                <p>氏名　　：{{ this.formData.order_name }}</p>
                <p>会社名　：{{ this.formData.order_company_name }}</p>
                <p>郵便番号：{{ this.formData.order_post_number_1 }} - {{ this.formData.order_post_number_2 }}</p>
                <p>住所１　：{{ this.formData.order_address_1 }}</p>
                <p>住所２　：{{ this.formData.order_address_2 }}</p>
                <p>電話番号：{{ this.formData.order_phone_number }}</p>
            </div>
            <div class="col-md-6">
                <h4 class="py-3">送付先情報</h4>
                <p>氏名　　：{{ this.formData.order_forwarding_name }}</p>
                <p>会社名　：{{ this.formData.order_forwarding_company_name }}</p>
                <p>郵便番号：{{ this.formData.order_forwarding_post_number_1 }} - {{ this.formData.order_forwarding_post_number_2 }}</p>
                <p>住所１　：{{ this.formData.order_forwarding_address_1 }}</p>
                <p>住所２　：{{ this.formData.order_forwarding_address_2 }}</p>
                <p>電話番号：{{ this.formData.order_forwarding_phone_number }}</p>
            </div>
        </div>

        <form class="col-md-12 py-3" @submit.prevent="handleOnSubmit">
            <div class="form-row py-3 justify-content-center">
                <div class="col-md-3">
                    <router-link :to="{ name: 'OrderAmount' }" class="text-center">
                        <span class="btn btn-light btn-block">戻る</span>
                    </router-link>
                </div>

                <div class="col-md-3 mt-2 mt-md-0">
                    <button v-on:submit.prevent type="submit" class="btn btn-primary btn-block">{{ $t('hec.policy.nextButton') }}</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import userService from "../../services/UserService";

    export default {
        name: 'OrderConfirm',

        components: {
        },

        data() {
            return {
                formData: {
                    order_name: "",
                    order_company_name: "",
                    order_post_number_1: "",
                    order_post_number_2: "",
                    order_address_1: "",
                    order_address_2: "",
                    order_phone_number: "",
                    order_forwarding_post_number_1: "",
                    order_forwarding_post_number_2: "",
                    order_forwarding_name: "",
                    order_forwarding_company_name: "",
                    order_forwarding_post_number_1: "",
                    order_forwarding_post_number_2: "",
                    order_forwarding_address_1: "",
                    order_forwarding_address_2: "",
                    order_forwarding_phone_number: "",
                    amount: "",
                    price: "",
                    tax: "",
                    total: ""
                },
                readyReadTerms: false,
                requireAgree: false,
            }
        },

        async created() {
            await this.getDefaultData();
        },

        methods: {

            async getDefaultData() {
                const map = new Map(Object.entries(this.formData));

                map.forEach((value, key) => {
                    this.formData[key] = sessionStorage.getItem(key);
                });
            },

            async handleOnSubmit() {
                this.$router.push('/dna/payment');
            },
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .state {
        padding-bottom: 10px;
        
        color: #888;
    }

    .state .active {
        color: #451493;
    }
</style>
